import type { ErrorEvent, EventHint } from "@sentry/node"
import { XError, getAllErrors } from "@/utils/error.utils"

const findExplicitFingerprint = (exception: unknown): string[] | undefined => {
    if (!(exception instanceof Error)) return undefined

    for (const error of getAllErrors(exception)) {
        if (error instanceof XError && error.fingerprint) {
            return error.fingerprint
        }
    }

    return undefined
}

export const applyXErrorFingerprint = (
    event: ErrorEvent,
    hint: EventHint
): ErrorEvent => {
    const fingerprint = findExplicitFingerprint(hint.originalException)

    if (fingerprint) {
        event.fingerprint = fingerprint
    }

    return event
}
